import type { RootState } from '~features';

const selectSubscribedChannels = (state: RootState) => state.pubsub.subscriptions.channels;

export { selectSubscribedChannels };
